import React from 'react';
import { Box, Flex, HStack, VStack } from '@chakra-ui/react';
import Wrapper from '@components/atoms/Wrapper';
import Media from '@components/atoms/Media';
import Link from '@components/atoms/Link';
import RichText from '@components/atoms/RichText';
import HeaderFont from '@components/atoms/HeaderFont';
import { dataLayerClick } from '@helpers/dataLayerPush';

const ContentBlockWithImage = ({ data = null }) => {
  const {
    contentBlockImage,
    content,
    contentBlockLink,
    footerHeading,
    footerLinks
  } = data;

  return (
    <Wrapper narrow>
      <Flex alignItems="center">
        <Media
          flex="1"
          media={contentBlockImage}
          w={{ md: `50%` }}
          mr={{ base: `0`, md: `7` }}
        />
        <Box
          w={{ md: `50%` }}
          flex="1"
          fontSize={{ base: `sm`, md: `2xl` }}
          lineHeight={{ base: `1.313rem`, md: `2.25rem` }}
          ml={{ base: `0`, md: `7` }}>
          <RichText data={content.data.content} />
        </Box>
      </Flex>
      <VStack pt="1.5rem" pb="5rem" spacing="0">
        {typeof contentBlockLink !== `undefined` &&
          contentBlockLink?.url &&
          contentBlockLink?.title && (
            <Link
              textAlign={{ base: `center`, md: `auto` }}
              href={contentBlockLink.url}
              mb="1.5rem"
              variant="purpleButton"
              fontSize="md"
              width={{ base: `100%`, sm: `auto` }}
              onClick={() => {
                dataLayerClick({
                  event: `cta_click`,
                  clickText: contentBlockLink.title,
                  clickUrl: contentBlockLink.url
                });
              }}>
              <HeaderFont>{contentBlockLink.title}</HeaderFont>
            </Link>
          )}
        {typeof footerHeading !== `undefined` && (
          <Box as="span" fontSize="sm" mt="0">
            {footerHeading}
          </Box>
        )}
        {typeof footerLinks !== `undefined` && footerLinks.length > 0 && (
          <HStack pt="1rem" spacing={{ base: `1.125rem`, md: `3rem` }}>
            {footerLinks.map((link) => {
              return (
                <Link
                  key={link.id}
                  href={link.url}
                  variant="purple"
                  fontSize={{ base: `sm`, md: `md` }}
                  textTransform="uppercase"
                  textDecoration="underline"
                  onClick={() => {
                    dataLayerClick({
                      event: `cta_click`,
                      clickText: link.title,
                      clickUrl: link.url
                    });
                  }}>
                  <HeaderFont>{link.title}</HeaderFont>
                </Link>
              );
            })}
          </HStack>
        )}
      </VStack>
    </Wrapper>
  );
};

export default ContentBlockWithImage;
